type actionType = 'create' | 'update' | 'read' | 'delete';

export const verifyAccess = (permissions?: string[], type?: 'customer' | 'driver', action?: actionType):boolean => {  
  if (permissions?.includes(`${type}:${action}`)) return true;
  return false
}